module.exports = __webpack_public_path__ + "img/tree-07-d-trunk.0047e37a.png";